import {
    forwardRef,
    useState,
    useContext,
} from 'react'

import ApplicantDataFormContext from "../../../../../../Contexts/ApplicantDataFormContext"

import {
    useMutation,
} from '@tanstack/react-query'

import generateConsentMutation from './services/generate-consent'
import Overlay from '../../../../../../Components/Overlay'

const Consent = forwardRef(({ }, ref) => {

    const applicantDataForm = useContext(ApplicantDataFormContext)

    const requestKey = applicantDataForm.current["requestKey"]
    const referenceNumber = applicantDataForm.current["referenceNumber"]

    const [isOpen, setIsOpen] = useState(false)

    const {
        error: generateConsentMutationError,
        isPending: generateConsentMutationIsPending,
        mutate: generateConsent,
        data: generateConsentMutationData,
    } = useMutation({
        mutationFn: generateConsentMutation,
        onSuccess: async (d) => {
            downloadPDF(d.url)
        }
    })

    return (

        <div>

            <button
                onClick={() => setIsOpen(!isOpen)}
                className="w-full flex justify-between items-center py-2 px-0"
            >
                <span className="text-lg font-semibold">Consent</span>
                <span className={`pr-4 flex items-center gap-1`}>{isOpen ? '▲' : '▼'}</span>
            </button>
            <div className={`${!isOpen ? 'hidden' : ''} pt-2 flex items-center justify-center`}>
                <div className="w-full bg-white rounded-2xl shadow-md p-8  ">
                    <h1 className="text-3xl font-bold text-gray-900 mb-6">
                        Consent & Disclosures Summary
                    </h1>

                    <p className="text-gray-700 mb-4">
                        <span className="font-semibold">Purpose:</span> To provide you with a summary of your consent and access to all relevant documents for your records.
                    </p>

                    <p className="text-gray-700 mb-4">
                        Thank you for completing the background check consent process. Your authorizations and acknowledgments have been successfully recorded.
                    </p>

                    <p className="text-gray-700 mb-4">
                        For your convenience and records, you can download a copy of all the legal disclosures and authorizations that you reviewed and provided during this background check process. This combined document includes:
                    </p>

                    <ul className="list-disc list-inside text-gray-700 space-y-1 mb-6">
                        <li>Your Electronic Signature Agreement</li>
                        <li>The Combined Consumer Report OR Investigative Consumer Report Disclosure</li>
                        <li>Your Acknowledgment of the Combined Background Check Disclosures</li>
                        <li>Any applicable State/City Specific Notices (e.g., California, New York)</li>
                        <li>Your Acknowledgment(s) of any applicable State/City Specific Notices</li>
                        <li>
                            Your Final Acknowledgment and Specific Authorizations for the Background Screening{" "}
                        </li>
                    </ul>

                    <div className="mt-6">
                        <h2 className="text-lg font-semibold text-gray-900 mb-2">
                            Download Your Consent Documents
                        </h2>
                        <p className="text-gray-700 mb-4">
                            To download a PDF containing all the documents you reviewed and signed electronically, please click the button below:
                        </p>
                        <button
                            className="bg-blue-600 text-white font-semibold py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors"
                            onClick={() => generateConsent({ key: requestKey, referenceNumber })}
                        >
                            Download All Consent Documents
                        </button>
                    </div>
                </div>
            </div>

            {
                generateConsentMutationIsPending &&
                <Overlay />
            }

        </div>
    )

})

const downloadPDF = (url) => {
    const link = document.createElement('a')
    link.href = url
    link.download = 'consent.pdf' // Optional: you can set a filename like 'file.pdf'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}

export default Consent
